
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// import axios from "axios";

// const WhatsappLogin = () => {
// const [whatsappNumber, setWhatsappNumber] = useState("");
// const [otp, setOtp] = useState("");
// const [otpCode, setOtpCode] = useState("");
// const [step, setStep] = useState(1); // 1: Enter Number, 2: Enter OTP
// const [message, setMessage] = useState("");

// const [error, setError] = useState("");
// const navigate = useNavigate();



// const sendOtp = async () => {
//     if (whatsappNumber.length !== 10) {
//         setMessage("Please enter a valid 10-digit WhatsApp number.");
//         return;
//     }

//     try {
//         const response = await axios.post("https://erpapi.emedha.in/pages/api/api/send-otp", {
//             whatsappNumber,
//         });

//         if (response.data.success) {
//             setMessage("OTP sent successfully.");
//             setOtpCode(response.data.otpCode); // Store OTP for verification
//             setStep(2);
//         }
//     } catch (error) {
//         setMessage(error.response?.data?.error || "Error sending OTP.");
//     }
// };


// const verifyOtp = async () => {
//     if (!otp) {
//         setMessage("Please enter a valid OTP.");
//         return;
//     }

//     try {
//         const response = await axios.post("https://erpapi.emedha.in/pages/api/api/verify-otp", {
//             whatsappNumber,
//             otpCode: otp,
//         });

//         // Check if the message indicates success
//         if (response.data.message === "OTP verified successfully") {
//             setMessage("OTP verified successfully!");

//             const userData = response.data.user;

//             if (userData) {
//                 // Assuming the token is a mock token for now, replace it with actual token if needed
//                 const token = "mock-token-for-user"; 

//                 // Store user data and auth token in session storage
//                 sessionStorage.setItem("user", JSON.stringify(userData));
//                 sessionStorage.setItem("authToken", token);

//                 // Navigate to the dashboard
//                 navigate("/dashboard");
//             } else {
//                 setError("User not found with this WhatsApp number.");
//             }
//         } else {
//             // In case the message is not success, show an error
//             setMessage("Invalid OTP. Try again.");
//         }
//     } catch (error) {
//         // Handle errors from the API request
//         setMessage(error.response?.data?.error || "Error verifying OTP.");
//     }
// };

//     return (
// <div className="container d-flex justify-content-center align-items-center min-vh-100">
//     <div
//         className="form-box text-center p-4 rounded shadow-sm"
//         style={{
//             maxWidth: "400px",
//             width: "100%",
//             backgroundColor: "#dbc4a9",
//             padding: "2rem",
//             boxSizing: "border-box",
//         }}
//     >
//         {/* <img
//             src={A1}
//             alt="Logo"
//             style={{
//                 width: "60%",
//                 maxWidth: "200px",
//                 marginBottom: "20px",
//             }}
//         /> */}

//         <div className="container">
//             <h1 className="text-primary mt-3 mb-4" style={{ fontSize: "2rem" }}>
//             <img
//                     src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Use your WhatsApp icon here
//                     alt="WhatsApp Icon"
//                     width="40"
//                     height="40"
//                 />
//                 WhatsApp Login
//             </h1>

//             {step === 1 ? (
//                 <>
//                     <input
//                         type="text"
//                         placeholder="Enter WhatsApp Number"
//                         value={whatsappNumber}
//                         onChange={(e) => setWhatsappNumber(e.target.value)}
//                         style={{
//                             width: "100%",
//                             padding: "10px",
//                             marginBottom: "15px",
//                             borderRadius: "5px",
//                             border: "1px solid #ccc",
//                         }}
//                     />
//                     <button
//                         onClick={sendOtp}
//                         style={{
//                             width: "100%",
//                             padding: "10px",
//                             backgroundColor: "#007bff",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "5px",
//                             cursor: "pointer",
//                         }}
//                     >
//                         Send OTP
//                     </button>
//                 </>
//             ) : (
//                 <>
//                     <input
//                         type="text"
//                         placeholder="Enter OTP"
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                         style={{
//                             width: "100%",
//                             padding: "10px",
//                             marginBottom: "15px",
//                             borderRadius: "5px",
//                             border: "1px solid #ccc",
//                         }}
//                     />
//                     <button
//                         onClick={verifyOtp}
//                         style={{
//                             width: "100%",
//                             padding: "10px",
//                             backgroundColor: "#007bff",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "5px",
//                             cursor: "pointer",
//                         }}
//                     >
//                         Verify OTP
//                     </button>
//                 </>
//             )}

//             {message && <p>{message}</p>}
//             {error && <p className="text-danger">{error}</p>}
//         </div>

//         <div className="forgot-link mb-3">
//             <Link to="/login" style={{ color: "black" }}>
//                 Login
//             </Link>
//         </div>
//     </div>

//     {/* Inline styles for responsiveness */}
//     <style>
//         {`
//             @media (max-width: 576px) {
//                 .form-box {
//                     max-width: 90% !important;
//                     padding: 1rem !important;
//                 }

//                 h1 {
//                     font-size: 1.5rem;
//                 }

//                 img {
//                     width: 50%;
//                 }
//             }
//         `}
//     </style>
// </div>
//     );
// };

// export default WhatsappLogin;



import React, { useState, useEffect } from 'react';
import './index.css'; // Import your custom styles
import logo1 from '../Images/logo1.jpeg';
import lionslogo from '../Images/lionslogo.png';
import header from '../Images/header.jpeg';
import lbnlogo from '../Images/lbnlogo.jpeg';

import { Link, useNavigate } from "react-router-dom";

import axios from "axios";


const WhatsappLogin = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Use the imported images for the slides
  const slides = [logo1, lionslogo, header, lbnlogo]; // Use your local image imports here

  const changeSlide = (direction) => {
    setCurrentSlide((prevSlide) => (prevSlide + direction + slides.length) % slides.length);
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      changeSlide(1);
    }, 3000);
    return () => clearInterval(slideInterval);
  }, []);



  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [step, setStep] = useState(1); // 1: Enter Number, 2: Enter OTP
  const [message, setMessage] = useState("");

  const [error, setError] = useState("");
  const navigate = useNavigate();



  const sendOtp = async () => {
    if (whatsappNumber.length !== 10) {
      setMessage("Please enter a valid 10-digit WhatsApp number.");
      return;
    }

    try {
      const response = await axios.post("https://api.lbnhyderabad.com/signup/api/send-otp", {
        whatsappNumber,
      });

      if (response.data.success) {
        setMessage("OTP sent successfully.");
        setOtpCode(response.data.otpCode); // Store OTP for verification
        setStep(2);
      }
    } catch (error) {

       const errorMessage =
      error.response?.data?.message || // For structured { message: "..." }
      error.response?.data?.error ||   // For structured { error: "..." }
      "Error sending OTP.";            // Fallback

    alert(errorMessage);

      setMessage(error.response?.data?.error || "Error sending OTP.");
    }
  };


  const verifyOtp = async () => {
    if (!otp) {
      setMessage("Please enter a valid OTP.");
      return;
    }

    try {
      const response = await axios.post("https://api.lbnhyderabad.com/signup/api/verify-otp", {
        whatsappNumber,
        otpCode: otp,
      });

      // Check if the message indicates success
      if (response.data.message === "OTP verified successfully") {
        setMessage("OTP verified successfully!");

        const userData = response.data.user;

        if (userData) {
          // Assuming the token is a mock token for now, replace it with actual token if needed
          const token = "mock-token-for-user";

          // Store user data and auth token in session storage
          sessionStorage.setItem("user", JSON.stringify(userData));
          sessionStorage.setItem("authToken", token);
          sessionStorage.setItem('email', userData.email);
          sessionStorage.setItem('loginType', userData.loginType);
          sessionStorage.setItem('userId', userData.id);  // Optionally store the user ID
          sessionStorage.setItem('loginType', 'User Login');
          // Navigate to the dashboard
          navigate("/user-dashboard");
        } else {
          setError("User not found with this WhatsApp number.");
        }
      } else {
        // In case the message is not success, show an error
        setMessage("Invalid OTP. Try again.");
      }
    } catch (error) {
      // Handle errors from the API request
      setMessage(error.response?.data?.error || "Error verifying OTP.");
    }
  };

  return (
    <div>
      <div className="main">
        <div className="card">
          {/* Left - Carousel */}
          <div className="left">
            <div className="carousel">
              <img alt="Slide 1" className={currentSlide === 0 ? 'active' : ''} src={slides[0]} />
              <img alt="Slide 2" className={currentSlide === 1 ? 'active' : ''} src={slides[1]} />
              <img alt="Slide 3" className={currentSlide === 2 ? 'active' : ''} src={slides[2]} />
              <img alt="Slide 4" className={currentSlide === 3 ? 'active' : ''} src={slides[3]} />
              <div className="prev" onClick={() => changeSlide(-1)}>&#10094;</div>
              <div className="next" onClick={() => changeSlide(1)}>&#10095;</div>
            </div>
          </div>

          {/* Right - Login Form */}
          <div className="right">
            <div className="container d-flex justify-content-center align-items-center min-vh-100">
              <div
                className="form-box text-center p-4 rounded shadow-sm w-100"
                style={{
                  maxWidth: "400px",
                  backgroundColor: "white",
                  boxSizing: "border-box",
                }}
              >
                <div className="container">
                  <h1 className="text-primary d-flex align-items-center justify-content-center gap-2 mb-4" style={{ fontSize: "2rem" }}>
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                      alt="WhatsApp Icon"
                      width="40"
                      height="40"
                    />
                    <span style={{ color: 'black' }}>WhatsApp Login</span>
                  </h1>

                  {step === 1 ? (
                    <>
                      <input
                        type="text"
                        placeholder="Enter WhatsApp Number"
                        value={whatsappNumber}
                        onChange={(e) => setWhatsappNumber(e.target.value)}
                        className="form-control mb-3"
                      />
                      <button
                        onClick={sendOtp}
                        className="btn btn-primary w-100"
                      >
                        Send OTP
                      </button>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        className="form-control mb-3"
                      />
                      <button
                        onClick={verifyOtp}
                        className="btn btn-primary w-100"
                      >
                        Verify OTP
                      </button>
                    </>
                  )}

                  {message && <p className="text-success mt-3">{message}</p>}
                  {error && <p className="text-danger mt-2">{error}</p>}
                </div>

                <div className="forgot-link mt-3">
                  <Link to="/login" style={{ color: "black" }}>
                    Login
                  </Link>
                </div>
              </div>
            </div>

            {/* Custom Responsive Styles */}
            <style>
              {`
      @media (max-width: 576px) {
        .form-box {
          max-width: 95% !important;
          padding: 1.5rem !important;
        }

        .form-box h1 {
          font-size: 1.5rem !important;
        }

        .form-box img {
          width: 30px !important;
          height: 30px !important;
        }
      }
    `}
            </style>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhatsappLogin;
